import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=f60ea236&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60ea236",
  null
  
)

export default component.exports